import { render, staticRenderFns } from "./GeneralLoader.vue?vue&type=template&id=76c3a9be&scoped=true"
import script from "./GeneralLoader.vue?vue&type=script&lang=js"
export * from "./GeneralLoader.vue?vue&type=script&lang=js"
import style0 from "./GeneralLoader.vue?vue&type=style&index=0&id=76c3a9be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c3a9be",
  null
  
)

export default component.exports